import React from 'react';
import styles from './track-queue.module.css';

const PlayIcon = ({ className }) => (
  <svg className={className || styles.icon} viewBox="0 0 24 24" fill="currentColor">
    <polygon points="8,5 8,19 19,12" />
  </svg>
);

export function TrackQueue({
  tracks,
  currentTrackIndex,
  onTrackSelect,
  className = '',
  maxVisible = 5
}) {
  // Хук вызываем безусловно
  const queueTracks = React.useMemo(() => {
    if (!Array.isArray(tracks) || tracks.length === 0) return [];

    const out = [];
    const safeIndex = Math.max(0, Math.min(currentTrackIndex || 0, tracks.length - 1));
    const current = tracks[safeIndex];

    if (current) {
      out.push({
        ...current,
        index: safeIndex,
        position: safeIndex + 1,
        isCurrent: true,
        key: `t-${current.id || safeIndex}-cur`
      });
    }

    const limit = Math.max(0, (maxVisible || 5) - 1);
    for (let i = 1; i <= limit && tracks.length > 1; i++) {
      const nextIndex = (safeIndex + i) % tracks.length;
      if (nextIndex !== safeIndex && tracks[nextIndex]) {
        const t = tracks[nextIndex];
        out.push({
          ...t,
          index: nextIndex,
          position: nextIndex + 1,
          isCurrent: false,
          key: `t-${t.id || nextIndex}-q-${i}`
        });
      }
    }

    return out;
  }, [tracks, currentTrackIndex, maxVisible]);

  // Теперь ранний выход — после хука
  if (queueTracks.length === 0) return null;

  const total = Array.isArray(tracks) ? tracks.length : 0;

  return (
    <div className={`${styles.wrap} ${className}`}>
      <div className={styles.top}>
        <h4 className={styles.h4}>Queue</h4>
        <span className={styles.badge}>{total} tracks</span>
      </div>

      <div className={styles.list}>
        {queueTracks.map((track) => (
          <div
            key={track.key}
            className={`${styles.row} ${track.isCurrent ? styles.current : ''}`}
            onClick={() => onTrackSelect && onTrackSelect(track.index)}
          >
            <div className={`${styles.pos} ${track.isCurrent ? styles.posActive : ''}`}>
              <span className={track.isCurrent ? styles.posNote : styles.posText}>
                {track.isCurrent ? '♪' : track.position}
              </span>
            </div>

            <div
              className={styles.avatar}
              style={{ backgroundImage: track.cover ? `url(${track.cover})` : 'none' }}
            >
              {!track.cover && <span className={styles.avatarNote}>♪</span>}
              <div className={styles.overlay}><PlayIcon /></div>
            </div>

            <div className={styles.meta}>
              <div className={styles.title} title={track.title}>
                {track.title}{track.isCurrent && <span className={styles.now}> (Now Playing)</span>}
              </div>
              <div className={styles.artist} title={track.artist}>{track.artist}</div>
            </div>

            <div className={styles.right}>
              {track.duration ? (
                <div className={styles.dur}>
                  {Math.floor(track.duration / 60)}:{String(Math.floor(track.duration % 60)).padStart(2, '0')}
                </div>
              ) : null}
              {track.format ? <div className={styles.fmt}>{track.format}</div> : null}
            </div>
          </div>
        ))}
      </div>

      {total > maxVisible + 1 && (
        <div className={styles.more}>+{total - maxVisible - 1} more tracks in queue</div>
      )}
    </div>
  );
}

